"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoomRateSummary = void 0;
const getRoomRateSummary = (rates, occupancy, extra_bed, margin_discount_percentage, applied_discount) => {
    const total_price = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        const cost_price = rate.cost_price;
        const board_surcharge = rate.board_surcharge;
        const extra_bed_cost = rate.extra_bed_cost || 0;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        return (acc +
            cost_price +
            dinners_cost +
            margin +
            (board_surcharge * occupancy || 0) +
            (extra_bed ? extra_bed_cost + board_surcharge || 0 : 0));
    }, 0);
    const total_price_discounted = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        let cost_price = rate.cost_price;
        let board_surcharge = rate.board_surcharge;
        let extra_bed_cost = rate.extra_bed_cost || 0;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        if (applied_discount &&
            applied_discount.best &&
            applied_discount?.best?.discount > 0) {
            if (applied_discount.apply_discount_to_board_surplus) {
                board_surcharge =
                    board_surcharge -
                        (board_surcharge * applied_discount.best.discount) / 100;
            }
            if (applied_discount.apply_discount_to_extra_bed) {
                extra_bed_cost =
                    extra_bed_cost -
                        (extra_bed_cost * applied_discount.best.discount) / 100;
            }
            margin = margin - (margin * applied_discount.best.discount) / 100;
            cost_price =
                cost_price - (cost_price * applied_discount.best.discount) / 100;
        }
        return (acc +
            cost_price +
            dinners_cost +
            margin +
            (board_surcharge * occupancy || 0) +
            (extra_bed ? extra_bed_cost + board_surcharge || 0 : 0));
    }, 0);
    const total_base_price = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        const cost_price = rate.cost_price;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        return acc + cost_price + dinners_cost + margin;
    }, 0);
    const total_base_price_discounted = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        let cost_price = rate.cost_price;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        if (applied_discount &&
            applied_discount?.best &&
            applied_discount?.best?.discount > 0) {
            cost_price =
                cost_price - (cost_price * applied_discount.best.discount) / 100;
        }
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
            if (applied_discount &&
                applied_discount.best &&
                applied_discount?.best?.discount > 0) {
                margin = margin - (margin * applied_discount.best.discount) / 100;
            }
        }
        return acc + cost_price + dinners_cost + margin;
    }, 0);
    const total_cost_price = rates.reduce((acc, rate) => {
        const cost_price = rate.cost_price;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        return acc + cost_price + dinners_cost;
    }, 0);
    const total_cost_price_discounted = rates.reduce((acc, rate) => {
        let cost_price = rate.cost_price;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        if (applied_discount &&
            applied_discount?.best &&
            applied_discount?.best?.discount > 0) {
            cost_price =
                cost_price - (cost_price * applied_discount.best.discount) / 100;
        }
        return acc + cost_price + dinners_cost;
    }, 0);
    const total_margin = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        return acc + margin;
    }, 0);
    const total_margin_discounted = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        if (applied_discount &&
            applied_discount?.best &&
            applied_discount?.best?.discount > 0) {
            margin = margin - (margin * applied_discount.best.discount) / 100;
        }
        return acc + margin;
    }, 0);
    const total_sell_price = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        const cost_price = rate.cost_price;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        return acc + cost_price + margin + dinners_cost;
    }, 0);
    const total_sell_price_discounted = rates.reduce((acc, rate) => {
        let margin = rate.margin;
        if (margin_discount_percentage) {
            margin = margin - (margin * margin_discount_percentage) / 100;
        }
        let cost_price = rate.cost_price;
        const dinners_cost = rate?.dinners?.reduce((acc, dinner) => acc + dinner.cost_price * occupancy, 0) ?? 0;
        if (applied_discount &&
            applied_discount?.best &&
            applied_discount?.best?.discount > 0) {
            margin = margin - (margin * applied_discount.best.discount) / 100;
            cost_price =
                cost_price - (cost_price * applied_discount.best.discount) / 100;
        }
        return acc + cost_price + margin + dinners_cost;
    }, 0);
    const total_surcharge = rates.reduce((acc, rate) => {
        const board_surcharge = rate.board_surcharge;
        return acc + board_surcharge * occupancy;
    }, 0);
    const total_surcharge_discounted = rates.reduce((acc, rate) => {
        let board_surcharge = rate.board_surcharge;
        if (applied_discount &&
            applied_discount.best &&
            applied_discount?.best?.discount > 0) {
            if (applied_discount.apply_discount_to_board_surplus) {
                board_surcharge =
                    board_surcharge -
                        (board_surcharge * applied_discount.best.discount) / 100;
            }
        }
        return acc + board_surcharge * occupancy;
    }, 0);
    const total_extra_bed_cost = rates.reduce((acc, rate) => {
        return (acc + (extra_bed ? rate.extra_bed_cost + rate.board_surcharge || 0 : 0));
    }, 0);
    const total_extra_bed_cost_discounted = rates.reduce((acc, rate) => {
        let board_surcharge = rate.board_surcharge;
        let extra_bed_cost = rate.extra_bed_cost || 0;
        if (applied_discount &&
            applied_discount.best &&
            applied_discount?.best?.discount > 0) {
            if (applied_discount.apply_discount_to_board_surplus) {
                board_surcharge =
                    board_surcharge -
                        (board_surcharge * applied_discount.best.discount) / 100;
            }
            if (applied_discount.apply_discount_to_extra_bed) {
                extra_bed_cost =
                    extra_bed_cost -
                        (extra_bed_cost * applied_discount.best.discount) / 100;
            }
        }
        return acc + (extra_bed ? extra_bed_cost + board_surcharge || 0 : 0);
    }, 0);
    return {
        total_price: total_price,
        total_price_discounted: total_price_discounted,
        total_price_discounted_diff: total_price - total_price_discounted,
        total_base_price: total_base_price,
        total_base_price_discounted: total_base_price_discounted,
        total_base_price_discounted_diff: total_base_price - total_base_price_discounted,
        total_cost_price: total_cost_price,
        total_cost_price_discounted: total_cost_price_discounted,
        total_cost_price_discounted_diff: total_cost_price - total_cost_price_discounted,
        total_margin: total_margin,
        total_margin_discounted: total_margin_discounted,
        total_margin_discounted_diff: total_margin - total_margin_discounted,
        total_sell_price: total_sell_price,
        total_sell_price_discounted: total_sell_price_discounted,
        total_sell_price_discounted_diff: total_sell_price - total_sell_price_discounted,
        total_surcharge: total_surcharge,
        total_surcharge_discounted: total_surcharge_discounted,
        total_extra_bed_cost: total_extra_bed_cost,
        total_extra_bed_cost_discounted: total_extra_bed_cost_discounted,
    };
};
exports.getRoomRateSummary = getRoomRateSummary;
